<template>
  <v-card class="mt-4 financial-card">
    <!-- Title slot permite override do título -->
    <slot name="title" v-bind="{ title }">
      <v-card-title class="topic__title financial--color">
        {{ title }}
      </v-card-title>
    </slot>
    <v-card-text class="topic__body">
      <slot name="loading" v-if="loading">
        <screen-loading margin="20px 25%" />
      </slot>
      <template v-else>
        <slot name="warnings"></slot>
        <FinancialTable
          :headers="headers"
          :slip-details-headers="slipDetailsHeaders"
          :items="items"
          :unit-financial-positions="unitFinancialPositions"
          :mode="mode"
          :no-data-text="noDataText"
          :sort-icon="sortIcon"
          :expand-column="expandColumn"
          totalKey="discountedValue"
        >
        </FinancialTable>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import FinancialTable from './FinancialTable.vue';
import ScreenLoading from '@/components/loaders/ScreenLoading';
export default {
  name: 'FinancialCardTable',
  components: {
    FinancialTable,
    ScreenLoading,
  },
  props: {
    title: { type: String, default: '' },
    headers: { type: Array, required: true },
    slipDetailsHeaders: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    unitFinancialPositions: { type: Object, required: true },
    mode: { type: String, required: true },
    loading: { type: Boolean, default: false },
    noDataText: { type: String, default: 'Nenhum dado encontrado' },
    hideActions: { type: Boolean, default: true },
    sortIcon: { type: String, default: 'bexsicon-down' },
    expandColumn: {
      type: String,
      default: 'slipsUnion',
    },
  },
};
</script>

<style lang="scss">
/* ======
 * Agrupamento de linha + expandida (CSS moderno com :has())
 * ====== */
.expanded-area {
  /* Linha 'top' quando logo abaixo vem uma expandida com conteúdo */

  tr:has(+ tr.v-datatable__expand-row) {
    cursor: pointer;
  }
  tr:has(+ tr.v-datatable__expand-row td.v-datatable__expand-col--expanded) {
    border: 1px solid #b3b1b1;
    border-bottom: none;

    .expanded-area-icon .v-icon {
      rotate: 90deg;
    }
  }

  /* Linha expandida */
  tr.v-datatable__expand-row:has(td.v-datatable__expand-col--expanded) {
    border: 1px solid #b3b1b1;
    border-top: none;

    .v-datatable__expand-col--expanded {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/financial/FinancialCardTable.vue